import {
  GroupScoreDto,
  GroupScoreModel,
} from 'api/dto/new/SummaryCompared/Categories/GroupScore.dto';
import {
  QuestionItemDetailsDto,
  QuestionItemDetailsModel,
} from 'api/dto/new/SummaryCompared/Questions/QuestionItemDetails.dto';

export type QuestionItemDto = {
  byGroup: Record<string, GroupScoreDto>;
  question: QuestionItemDetailsDto;
};

export type QuestionItemModel = {
  byGroup: Record<string, GroupScoreModel>;
  question: QuestionItemDetailsModel;
};

export const mapQuestionItemDtoToModel = (dto: QuestionItemDto): QuestionItemModel => ({
  byGroup: dto.byGroup,
  question: dto.question,
});
